const Alarms = () => import("./views/alarms/alarms.vue");
const PropertiesV1Settings = () =>
	import("./views/configuration/views/properties/properties.vue");
const PropertiesV1Gateways = () =>
	import("./views/configuration/views/properties/properties-gateways.vue");
const EquipmentV1Settings = () => import("./views/configuration/Settings.vue");
const EquipmentList = () =>
	import("./views/configuration/views/equipment/equipment-list.vue");
const EquipmentAdd = () =>
	import("./views/configuration/views/equipment/views/equipment-add.vue");
const BulkConfiguration = () =>
	import(
		"./views/configuration/views/equipment/views/bulk-configuration/bulk-configuration.vue"
	);
const EquipmentBulkCreation = () =>
	import("./views/equipment-bulk-creation/equipment-bulk-creation.vue");
const BacnetBulkImport = () =>
	import(
		"./views/configuration/views/equipment/views/bacnet-bulk-import/bacnet-bulk-import.vue"
	);
const BulkDownlink = () =>
	import(
		"../box/views/configuration/views/equipment/views/bulk-downlink/bulk-downlink.vue"
	);
const AutoDiscoveryV1Settings = () =>
	import("./views/configuration/views/autodiscovery/auto-discovery.vue");
const NetworkV1Settings = () =>
	import("./views/configuration/views/networks/network-list.vue");
const ConnectorV1Settings = () =>
	import("./views/configuration/views/connectors/connectors-list.vue");
const GatewayInterfacesSettings = () =>
	import("./views/configuration/views/gateways/gateways.vue");
const RoutingSettings = () =>
	import("./views/configuration/views/routing/routing-list.vue");
const WizardGateway = () =>
	import("./views/configuration/views/gateways/wizard-gateway.vue");
const WizardConfiguration = () =>
	import(
		"./views/configuration/views/wizard-configuration/wizard-configuration.vue"
	);
const VirtualPropertiesConfiguration = () =>
	import(
		"./views/configuration/views/virtual-properties/virtual-properties.vue"
	);
const LogsEvents = () => import("./views/logs/views/events.vue");
const LogsCommands = () => import("./views/logs/views/commands.vue");
const LogsProperties = () => import("./views/logs/views/properties.vue");
const LogsCampaigns = () => import("./views/logs/views/campaigns.vue");
const LogsCampaignDetails = () =>
	import("./views/logs/views/campaign-details.vue");
const ListAlarms = () => import("./views/alarms/list-alarms.vue");
const HistorySection = () => import("./views/alarms/history-section.vue");
const AlarmHistoryDetails = () =>
	import("./views/alarms/components/alarm-history/alarm-history-details.vue");
const SelectAlarm = () =>
	import("./views/alarms/components/alarm-history/select-alarm.vue");

const MbusScan = () =>
	import("./views/configuration/views/mbus-scan/mbus-scan.vue");

const PropertiesBulkCreation = () =>
	import(
		"./views/configuration/views/properties/views/bulk/modbus/modbus-properties-bulk-creation.vue"
	);

export default [
	// V1
	{
		path: "/boxes/v1/:id",
		name: "box-v1",
		component: () => import("./Box.vue"),
		meta: {
			requiresAuth: true,
			deviceType: "box"
		},
		children: [
			{
				// it will render this component on routes like: /boxes/v1/{boxid} or  /boxes/v1/{boxid}/settings
				alias: ["", "/boxes/v1/:id"],
				name: "box-v1-settings-all",
				path: "settings",
				component: EquipmentV1Settings,
				children: [
					{
						// it will render this component on routes like: /boxes/v1/{boxid}, /boxes/v1/{boxid}/settings, /boxes/v1/{boxid}/settings/equipments or /boxes/v1/{boxid}/equipments
						alias: ["", "/boxes/v1/:id"],
						name: "box-v1-settings",
						path: "equipments",
						components: {
							settings: EquipmentList
						}
					},
					{
						name: "box-v1-settings-equipments",
						path: "equipments",
						components: {
							settings: EquipmentList
						}
					},
					{
						name: "box-v1-settings-equipments-add",
						path: "equipments/add",
						components: {
							settings: EquipmentAdd
						}
					},
					{
						name: "box-v1-settings-bulk-update-config",
						path: "equipments/bulk-configuration",
						components: {
							settings: BulkConfiguration
						}
					},
					{
						name: "box-v1-settings-bulk-downlink",
						path: "equipments/bulk-downlink",
						components: {
							settings: BulkDownlink
						}
					},
					{
						name: "box-v1-settings-equipment-bulk-creation",
						path: "equipments/bulk-creation",
						components: {
							settings: EquipmentBulkCreation
						}
					},
					{
						name: "box-v1-settings-equipment-bulk-bacnet",
						path: "equipments/bulk-bacnet",
						components: {
							settings: BacnetBulkImport
						}
					},
					{
						name: "box-v1-settings-properties",
						path: "equipments/:equipmentId/properties",
						redirect: {
							name: "box-v1-settings-properties-list"
						},
						children: [
							{
								path: "",
								name: "box-v1-settings-properties-list",
								components: {
									settings: PropertiesV1Settings
								}
							},
							{
								path: "bulk",
								name: "box-v1-settings-properties-bulk-creation",
								components: {
									settings: PropertiesBulkCreation
								}
							}
						]
					},
					{
						name: "box-v1-settings-wizard-configuration",
						path: "wizard-configuration",
						components: {
							settings: WizardConfiguration
						}
					},
					{
						name: "box-v1-settings-networks",
						path: "networks",
						components: {
							settings: NetworkV1Settings
						}
					},
					{
						name: "box-v1-settings-network-autodiscovery",
						path: "networks/:networkId/autodiscovery",
						components: {
							settings: AutoDiscoveryV1Settings
						}
					},
					{
						name: "box-v1-settings-network-mbus-scan",
						path: "networks/:networkId/mbus-scan",
						components: {
							settings: MbusScan
						}
					},
					{
						name: "box-v1-settings-connectors",
						path: "connectors",
						components: {
							settings: ConnectorV1Settings
						}
					},
					{
						name: "box-v1-settings-gateways",
						path: "gateways",
						components: {
							settings: GatewayInterfacesSettings
						}
					},
					{
						name: "box-v1-settings-gateways-properties",
						path: "gateways/:gatewayId/properties",
						components: {
							settings: PropertiesV1Gateways
						}
					},
					{
						name: "box-v1-settings-gateways-wizard",
						path: "gateways/:gatewayId/wizard-gateway",
						components: {
							settings: WizardGateway
						}
					},

					{
						name: "box-v1-settings-routing",
						path: "routing",
						components: {
							settings: RoutingSettings
						}
					},
					{
						name: "box-v1-settings-virtual-properties",
						path: "virtual-properties",
						components: {
							settings: VirtualPropertiesConfiguration
						}
					},

					{
						name: "box-v1-settings-scheduling-all",
						path: "scheduling",
						components: {
							settings: () =>
								import("./views/scheduling/scheduling-all.vue")
						},
						children: [
							{
								alias: [""],
								name: "box-v1-settings-scheduling",
								path: "",
								components: {
									view: () =>
										import(
											"./views/scheduling/components/scheduling.vue"
										)
								}
							},
							{
								name: "box-v1-settings-scheduling-add",
								path: "add",
								components: {
									view: () =>
										import(
											"./views/scheduling/components/schedule-edit.vue"
										)
								}
							},
							{
								name: "box-v1-settings-scheduling-edit",
								path: "edit/:scheduleId",
								components: {
									view: () =>
										import(
											"./views/scheduling/components/schedule-edit.vue"
										)
								}
							}
						]
					}
				]
			},
			{
				name: "box-v1-live-data",
				path: "live-data",
				component: () => import("./views/live-data/live-data.vue")
			},
			{
				name: "box-v1-graph",
				path: "graph",
				component: () => import("./views/graph/graph.vue")
			},
			{
				name: "box-v1-dashboard",
				path: "dashboard",
				component: () => import("./views/dashboards/dashboard.vue")
			},
			{
				name: "box-v1-archives",
				path: "archives",
				component: () => import("./views/archives/archives.vue"),
				redirect: { name: "box-v1-archives-list" },
				children: [
					{
						path: "",
						alias: ["list"],
						name: "box-v1-archives-list",
						components: {
							archives: () =>
								import(
									"./views/archives/views/archives-list.vue"
								)
						}
					},
					{
						path: "recurring",
						name: "box-v1-archives-recurring-list",
						components: {
							archives: () =>
								import(
									"./views/archives/views/archives-recurring.vue"
								)
						}
					}
				]
			},
			{
				name: "box-v1-alarms-all",
				path: "alarms",
				component: Alarms,
				children: [
					{
						alias: "",
						name: "box-v1-alarms-configuration",
						path: "configuration",
						component: ListAlarms
					},
					{
						name: "box-v1-alarms-list-history-all",
						path: "list-history",
						component: HistorySection,
						children: [
							{
								name: "box-v1-alarms-list-history",
								path: "",
								component: SelectAlarm
							},
							{
								name: "box-v1-alarms-list-history-item",
								path: ":alarmId",
								component: AlarmHistoryDetails
							}
						]
					}
				]
			},
			{
				name: "box-v1-logs",
				path: "logs",
				component: () => import("./views/logs/logs.vue"),
				redirect: {
					name: "box-v1-logs-campaigns"
				},
				props: {
					type: "box"
				},
				children: [
					{
						alias: "",
						name: "box-v1-logs-events",
						path: "events",
						components: {
							logsView: LogsEvents
						}
					},
					{
						name: "box-v1-logs-commands",
						path: "commands",
						components: {
							logsView: LogsCommands
						}
					},
					{
						name: "box-v1-logs-properties",
						path: "properties",
						components: {
							logsView: LogsProperties
						}
					},
					{
						name: "box-v1-logs-campaigns",
						path: "campaigns",
						components: {
							logsView: LogsCampaigns
						}
					},
					{
						name: "box-v1-logs-campaign-details",
						path: "campaigns/:campaignId",
						components: {
							logsView: LogsCampaignDetails
						}
					}
				]
			},
			{
				name: "box-v1-heating-optimiser",
				path: "heating-optimiser",
				component: () =>
					import("./views/heating-optimiser/heating-optimiser.vue")
			},
			{
				name: "box-v1-program",
				path: "program",
				component: () => import("./views/program/program.vue"),
				redirect: {
					name: "box-v1-program-scheduling"
				},
				props: {
					type: "box"
				},
				children: [
					{
						alias: [""],
						name: "box-v1-program-scheduling-all",
						path: "schedule",
						components: {
							programView: () =>
								import("./views/scheduling/scheduling-all.vue")
						},
						children: [
							{
								alias: [""],
								name: "box-v1-program-scheduling",
								path: "",
								components: {
									view: () =>
										import(
											"./views/scheduling/components/scheduling.vue"
										)
								}
							},
							{
								name: "box-v1-program-scheduling-add",
								path: "add",
								components: {
									view: () =>
										import(
											"./views/scheduling/components/schedule-edit.vue"
										)
								}
							},
							{
								name: "box-v1-program-scheduling-edit",
								path: "edit/:scheduleId",
								components: {
									view: () =>
										import(
											"./views/scheduling/components/schedule-edit.vue"
										)
								}
							}
						]
					},
					{
						name: "box-v1-program-automation",
						path: "automation",
						components: {
							programView: () =>
								import("./views/automation/automation.vue")
						}
					},
					{
						name: "box-v1-program-automation-history",
						path: "automation/history/:scenarioId/:instanceId",
						components: {
							programView: () =>
								import("./views/automation/history-view.vue")
						}
					}
				]
			}
		]
	},
	{
		name: "box-v1-automation-add",
		path: "/boxes/v1/:id/program/automation/add",
		component: () => import("./views/automation/scenario-edit.vue"),
		meta: {
			requiresAuth: true,
			layout: "full-screen"
		}
	},
	{
		name: "box-v1-automation-edit",
		path: "/boxes/v1/:id/program/automation/:automationId",
		component: () => import("./views/automation/scenario-edit.vue"),
		meta: {
			requiresAuth: true,
			layout: "full-screen"
		}
	},
	{
		path: "/boxes/v1/:id/:pathMatch(.*)*",
		name: "box-not-found",
		meta: {
			requiresAuth: true
		},
		component: () => import("../errors/NotFound.vue")
	},
	{
		path: "/boxes/:id/:oldBox(.*)*",
		name: "box",
		meta: {
			requiresAuth: true
		},
		component: () => import("./views/old-config/old-config.vue")
	}
];
